"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HistogramBar", {
  enumerable: true,
  get: function () {
    return _HistogramBar.HistogramBar;
  }
});
Object.defineProperty(exports, "HistogramBarData", {
  enumerable: true,
  get: function () {
    return _HistogramBar.HistogramBarData;
  }
});
var _HistogramBar = require("./HistogramBar");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfSGlzdG9ncmFtQmFyIiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hpc3RvZ3JhbS9IaXN0b2dyYW1CYXIvaW5kZXgudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEhpc3RvZ3JhbUJhciwgSGlzdG9ncmFtQmFyRGF0YSB9IGZyb20gXCIuL0hpc3RvZ3JhbUJhclwiXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsSUFBQUEsYUFBQSxHQUFBQyxPQUFBIiwiaWdub3JlTGlzdCI6W119